import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { parseLabel } from './parseLabel';

export const trackHeaderNavClick = (label: string) => {
  const category = parseLabel(label);

  sendTrackingEvent('HEADER_TAP', { header_category: category });
};
